import { useLayoutEffect } from 'react'
import { hostWindow } from '../../shared/host_window'

// Marks the host document while a V2 leaderboard is embedded in it.
//
// On the portal the leaderboard runs inside an iframe, and the page around it
// pins its width for anything at tablet size and up — which a phone in
// landscape is, by width. That outer document cannot tell a V2 leaderboard from
// the old one: both are served by the same widget URL, and neither leaves a
// trace outside the frame. So the leaderboard says so itself, and
// website_b/websites.sass keys the landscape-phone width off this class.
const HOST_CLASS = 'lbv2-embed'

// The host page's body when there is a reachable host other than ourselves
// (shared/host_window); nothing to mark on the manager site or a foreign host.
const getHostBody = () => {
  const host = hostWindow()
  return host === window ? null : host.document.body
}

// Applied in a layout effect, not a plain one: the host's width changes when the
// class lands, and after paint that reflow is visible as the page snapping from
// the narrow column to full width.
//
// The class is boolean, not refcounted, and multi-widget pages can host two V2
// leaderboards marking the same body. That is safe TODAY only because the root
// never unmounts inside a living iframe (teardown is always document unload,
// which skips React cleanups). If a refactor makes this root unmount
// conditionally - error boundary remount, view-mode gating - the first
// instance's cleanup will strip the class from under a surviving sibling and
// snap the landscape-phone page back to the narrow column: refcount on
// body.dataset at that point (a module counter won't do - each iframe is its
// own JS realm).
const useEmbedHostClass = () => {
  useLayoutEffect(() => {
    const body = getHostBody()
    if (!body) {
      return undefined
    }

    body.classList.add(HOST_CLASS)
    return () => body.classList.remove(HOST_CLASS)
  }, [])
}

export default useEmbedHostClass
